// 常量配置

export default {
    // tencentUploadEnv:process.env.NODE_ENV==='production'?'production':process.env.NODE_ENV,
    tencentUploadEnv:process.env.NODE_ENV,
    tencentUploadBucket:'n4a-static-1252926746',//存储桶的名称
    tencentUploadRegion:'ap-shanghai', //存储桶所在地域
    tencentUploadDomain:'//vrstatic.n4a.org.cn/',//存储桶的自定义加速域名
    //articleDefaultCover:"//vrstatic.n4a.org.cn/XSJ/backstage/article/defaultCover.png",//360*300 文章默认封面
    articleDefaultCover:"//vrstatic.n4a.org.cn/XSJ/backstage/article/defaultCover.jpg", //352*198 文章默认封面
    articleTypeList:[//文章类型
        {value:'党建工作',label:'党建工作'},
        // {value:'馆内新闻',label:'馆内新闻'},
        // {value:'最新公告',label:'最新公告'},
    ],
    articleStatusList:[//文章状态  online-在线，offline-不在线
        {value:'online',label:'已发布'},
        {value:'offline',label:'未发布'},
    ],

    culRelicStatusList:[//文物状态  online-在线，offline-不在线
        {value:'online',label:'已发布'},
        {value:'offline',label:'未发布'},
    ],
}
